import { useFormikContext } from 'formik';
import React from 'react';
import { Col } from 'react-bootstrap';

import SelectField from 'Shared/form/SelectField';
import { highRiskOptions } from '../../constants';
import CommonPatientFieldWrapper from '../CommonPatientFieldWrapper';

const HighRiskField = () => {
    const { setFieldValue } = useFormikContext();

    return (
        <CommonPatientFieldWrapper fieldName="highRisk">
            {(commonProps) => (
                <Col md={3}>
                    <SelectField
                        {...commonProps}
                        label="High-Risk"
                        options={highRiskOptions}
                        filterOptionType="startsWith"
                        onChange={(value) => {
                            setFieldValue('highRisk', value);
                            setFieldValue('highRiskReasons', []);
                        }}
                    />
                </Col>
            )}
        </CommonPatientFieldWrapper>
    );
};

export default HighRiskField;
